import { __extends } from "tslib";
import React from 'react';
import get from 'lodash/get';
import throttle from 'lodash/throttle';
var THROTTLE_TIMEOUT = 100;
var APPEND_STYLES_TIMEOUT = 20;
var ContainerSize = /** @class */ (function (_super) {
    __extends(ContainerSize, _super);
    function ContainerSize() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            width: undefined,
            height: undefined,
        };
        _this.saveContainerRef = function (ref) {
            _this.containerRef = ref;
        };
        _this.updateSize = throttle(function () {
            // wait for new stiles present by element queries
            return setTimeout(function () {
                return requestAnimationFrame(function () {
                    var size = _this.getContainerSize();
                    if (size.width === _this.state.width &&
                        size.height === _this.state.height) {
                        return;
                    }
                    _this.mounted && _this.setState(size);
                });
            }, APPEND_STYLES_TIMEOUT);
        }, THROTTLE_TIMEOUT, { leading: false });
        return _this;
    }
    ContainerSize.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.updateSize);
        this.updateSize();
        this.mounted = true;
    };
    ContainerSize.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.updateSize);
        this.mounted = false;
    };
    ContainerSize.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children;
        var _b = this.state, width = _b.width, height = _b.height;
        // this is to fixate container size to ceil'ed values
        var style = width && height
            ? {
                width: width,
                height: height,
                // padding in such cases is used to set flexible ratio
                // e.g. width 100%, height via padding-top|bottom: calc(100% * 9/6) so that it's relative to width
                // once we fixate the dims, it becomes extraneous
                padding: 0,
            }
            : {};
        return (React.createElement("div", { style: style, ref: this.saveContainerRef, className: className }, children({ width: width, height: height })));
    };
    ContainerSize.prototype.getContainerSize = function () {
        return {
            width: Math.ceil(get(this.containerRef, 'clientWidth', 0)),
            height: Math.ceil(get(this.containerRef, 'clientHeight', 0)),
        };
    };
    return ContainerSize;
}(React.Component));
export default ContainerSize;
//# sourceMappingURL=ContainerSize.js.map